import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { SectionHeaderComponent } from '../partsCommon/section-header/section-header.component';
import { BarcodeButtonComponent } from '../partsCommon/barcode-button/barcode-button.component';
import { CsvReaderComponent } from '../partsCommon/csv-reader/csv-reader.component';
import { CsvTableComponent } from '../partsCommon/csv-table/csv-table.component';
import { CsvTableStoreComponent } from '../partsCommon/csv-table-store/csv-table-store.component';
import { CtgParamComponent } from '../partsCommon/ctg-param/ctg-param.component';
import { CtgSelectComponent } from '../partsCommon/ctg-select/ctg-select.component';
import { CtgSelectNewComponent } from '../partsCommon/ctg-select-new/ctg-select-new.component';
import { DateRangeComponent } from '../partsCommon/date-range/date-range.component';
import { ItemHistListComponent } from '../partsCommon/item-hist-list/item-hist-list.component';
import { ItemListComponent } from '../partsCommon/item-list/item-list.component';
import { ItemListLimitTimeParamComponent } from '../partsCommon/item-list-limit-time-param/item-list-limit-time-param.component';
import { ItemListSimpleComponent } from '../partsCommon/item-list-simple/item-list-simple.component';
import { ItemSelectConditionComponent } from '../partsCommon/item-select-condition/item-select-condition.component';
import { ItemSelectSimpleComponent } from '../partsCommon/item-select-simple/item-select-simple.component';
import { ItemSummaryComponent } from '../partsCommon/item-summary/item-summary.component';
import { LoginBarComponent } from '../partsCommon/login-bar/login-bar.component';
import { NoisecutHistoryComponent } from '../partsCommon/noisecut-history/noisecut-history.component';
import { NotificationComponent } from '../partsCommon/notification/notification.component';
import { NumberKeypadComponent } from '../partsCommon/number-keypad/number-keypad.component';
import { RackSelectComponent } from '../partsCommon/rack-select/rack-select.component';

@NgModule({
  imports: [
    CommonModule,
    CdkTableModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatAutocompleteModule,
    // MatBadgeModule,
    // MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    // MatCardModule,
    MatCheckboxModule,
    // MatChipsModule,
    // MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    // MatDividerModule,
    // MatExpansionModule,
    // MatGridListModule,
    MatIconModule,
    MatInputModule,
    // MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    // MatProgressBarModule,
    MatProgressSpinnerModule,
    // MatRadioModule,
    // MatRippleModule,
    // MatSelectModule,
    // MatSidenavModule,
    // MatSliderModule,
    // MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    // MatTreeModule,
    DragDropModule,
    NgxChartsModule,
  ],
  declarations: [
    SectionHeaderComponent,
    BarcodeButtonComponent,
    CsvReaderComponent,
    CsvTableComponent,
    CsvTableStoreComponent,
    CtgParamComponent,
    CtgSelectComponent,
    CtgSelectNewComponent,
    DateRangeComponent,
    ItemHistListComponent,
    ItemListComponent,
    ItemListLimitTimeParamComponent,
    ItemListSimpleComponent,
    ItemSelectConditionComponent,
    ItemSelectSimpleComponent,
    ItemSummaryComponent,
    LoginBarComponent,
    NoisecutHistoryComponent,
    NotificationComponent,
    NumberKeypadComponent,
    RackSelectComponent,
    SectionHeaderComponent,
  ],
  exports: [
    SectionHeaderComponent,
    BarcodeButtonComponent,
    CsvReaderComponent,
    CsvTableComponent,
    CsvTableStoreComponent,
    CtgParamComponent,
    CtgSelectComponent,
    CtgSelectNewComponent,
    DateRangeComponent,
    ItemHistListComponent,
    ItemListComponent,
    ItemListLimitTimeParamComponent,
    ItemListSimpleComponent,
    ItemSelectConditionComponent,
    ItemSelectSimpleComponent,
    ItemSummaryComponent,
    LoginBarComponent,
    NoisecutHistoryComponent,
    NotificationComponent,
    NumberKeypadComponent,
    RackSelectComponent,
  ],
})
export class PartsCommonModule { }
